/*
  Yas Cosmetics: product share menu.
  - Copy link: copies the product link and announces it.
  - Instagram / TikTok: these apps have no web address for sharing a link. On phones the
    system share sheet opens (the apps appear there when installed); elsewhere the link is
    copied and the visitor is told where to paste it.
*/
(() => {
  const copy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (e) {
      const field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      let ok = false;
      try { ok = document.execCommand('copy'); } catch (err) { ok = false; }
      field.remove();
      return ok;
    }
  };

  const isTouch = () => window.matchMedia('(hover: none) and (pointer: coarse)').matches;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-yas-share] [data-yas-copy], [data-yas-share] [data-yas-share-app]');
    if (!button) return;
    const root = button.closest('[data-yas-share]');
    const status = root.querySelector('.yas-share__status');
    const url = root.dataset.url;
    const title = root.dataset.title;
    const say = (message) => {
      status.textContent = '';
      window.setTimeout(() => { status.textContent = message; }, 30);
      window.clearTimeout(root._yasTimer);
      root._yasTimer = window.setTimeout(() => { status.textContent = ''; }, 5000);
    };

    if (button.hasAttribute('data-yas-share-app')) {
      const app = button.dataset.yasShareApp;
      if (navigator.share && isTouch()) {
        try {
          await navigator.share({ title, url });
          return;
        } catch (e) {
          if (e && e.name === 'AbortError') return;
        }
      }
      if (await copy(url)) say(root.dataset.copiedFor.replace('__APP__', app));
      return;
    }

    if (await copy(url)) say(root.dataset.copied);
  });
})();
